export default () => ({
  clinicDays: {},
  clinicExceptions: []
})
